module.exports = __webpack_public_path__ + "static/media/vegi.9e3b3858.jpeg";